const getCarouselCards = (t, { isEnabledReferral, defaultTextReferral, isEnabledSocial }) => [
    {
        icon: 'bag-money',
        title: t('money.title'),
        description: t('money.description')
    },
    {
        icon: 'confetti',
        title: t('every-purchase.title'),
        description: t('every-purchase.description'),
        widthIcon: '19px',
        heightIcon: '19px'
    },
    {
        icon: 'money',
        title: t('coins.title'),
        description: t('coins.description'),
        widthIcon: '21px',
        heightIcon: '21px'
    },
    {
        icon: 'star',
        title: t('share.title'),
        description: t('share.description'),
        widthIcon: '21px',
        heightIcon: '21px',
        disabled: !isEnabledSocial
    },
    {
        icon: 'box',
        title: t('discount.title'),
        description: t('discount.description'),
        widthIcon: '20px',
        heightIcon: '20px'
    },
    {
        icon: 'glasses',
        title: t(`refer.${defaultTextReferral ? 'default' : 'reward'}.title`),
        description: t(`refer.${defaultTextReferral ? 'default' : 'reward'}.description`),
        widthIcon: '20px',
        heightIcon: '20px',
        disabled: !isEnabledReferral
    },
    {
        icon: 'ray',
        title: t('signup.title'),
        description: t('signup.description'),
        widthIcon: '21px',
        heightIcon: '25px'
    }
];
export default getCarouselCards;
